import { render } from "./TestTabs.vue?vue&type=template&id=56ce92c6"
import script from "./TestTabs.vue?vue&type=script&lang=js"
export * from "./TestTabs.vue?vue&type=script&lang=js"

import "./TestTabs.vue?vue&type=style&index=0&id=56ce92c6&lang=css"
script.render = render

export default script